/* Progressive enhancement. Navigation, search and checkout work without this file. */
(() => {
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ml-mobile-menu[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.ml-mobile-menu[open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  let pending;
  const syncCartCount = () => {
    clearTimeout(pending);
    pending = setTimeout(async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {headers: {'Accept': 'application/json'}});
        if (!response.ok) return;
        const cart = await response.json();
        document.querySelectorAll('[data-ml-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
          el.closest('a')?.setAttribute('aria-label', `Shopping bag, ${cart.item_count} items`);
        });
      } catch { /* Native cart remains available if this background refresh fails. */ }
    }, 100);
  };
  import('@shopify/events').then(({StandardEvents}) => {
    document.addEventListener(StandardEvents.cartLinesUpdate, event => {
      Promise.resolve(event.promise).then(syncCartCount).catch(() => {});
    });
  }).catch(() => {});
  document.addEventListener('cart:update', syncCartCount);
  document.addEventListener('cart:refresh', syncCartCount);
  window.addEventListener('pageshow', event => { if (event.persisted) syncCartCount(); });
})();
